import React, { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";
import ImageItem from "./ImageItem";
import { Typography } from "@mui/material";

import img from "../../../Images/OS_3_WWW_Home_1a.webp";
import img2 from "../../../Images/OS_3_WWW_Home_1b.webp";

const images = [
  {
    image: img,
    title:
      "Life gets busy—but when your home technology is connected into one simple-to-use system, it helps take away some of those daily little stresses. A true smart home makes your life more convenient and your home safer, more comfortable, and easy to enjoy.",
    btn: "Learn More About OS 3",
  },
  {
    image: img2,
    title:
      "A smart home operating system (OS) connects virtually all of the technology in your home. With meetfutur Smart Home OS 3, you and your family can control nearly every device and system in the house in ways that are easy and fun to use.",
    btn: "Learn More About OS 3",
  },
];

function ImageScrollInfo() {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { amount: 0.1 });
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(
    scrollYProgress,
    [0, 0.2, 0.3, 0.7, 0.8, 1],
    [0, 0, 1, 1, 0, 0]
  );

  const translateY = useTransform(
    scrollYProgress,
    [0, 0.2, 0.3, 0.7, 0.8, 1],
    [50, 50, 0, 0, -50, -50]
  );

  const textOpacity = useTransform(
    scrollYProgress,
    [0, 0.4, 0.45, 1],
    [1, 1, 0, 0]
  );

  const textOpacity2 = useTransform(
    scrollYProgress,
    [0, 0.45, 0.5, 1],
    [0, 0, 1, 1]
  );

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(isInView);
  }, [isInView]);

  return (
    <div
      id="boxInfoShow"
      ref={containerRef}
      className="flex flex-col md:gap-10 relative min-h-max md:min-h-[150vh] bg-white"
    >
      {show && (
        <motion.div
          className="flex-col items-start justify-center gap-6 fixed top-[calc(50vh_-_310px)] right-0 h-[620px] bg-[#f6f6f7] px-10 z-20 md:w-[430px] lg:w-[500px] xl:w-[550px] 2xl:w-[600px] hidden md:flex"
          style={{
            opacity: opacity,
            y: translateY,
          }}
        >
          <Typography
            variant="subtitle1"
            color="primary.dark"
            textTransform="uppercase"
            fontWeight={300}
            fontSize={{ md: 14, xl: 16 }}
            letterSpacing={1}
          >
            Smart Home | Operating System
          </Typography>
          <Typography
            variant="h4"
            color="primary.content"
            textTransform="uppercase"
            fontSize={{ md: 26, xl: 34 }}
          >
            <b>Your Home.</b>
            <br />
            <span className="font-light">Simplified.</span>
          </Typography>
          <div className="relative w-full">
            <motion.p
              className="relative font-light"
              style={{
                opacity: textOpacity,
                zIndex: textOpacity,
              }}
            >
              Life gets busy—but when your home technology is connected into one
              simple-to-use system, it helps take away some of those daily
              little stresses. A true smart home makes your life more convenient
              and your home safer, more comfortable, and easy to enjoy.
            </motion.p>
            <motion.p
              className="absolute top-0 leading-7 font-light"
              style={{
                opacity: textOpacity2,
                zIndex: textOpacity2,
              }}
            >
              A smart home operating system (OS) connects virtually all of the
              technology in your home. With meetfutur Smart Home OS 3, you and
              your family can control nearly every device and system in the
              house in ways that are easy and fun to use.
            </motion.p>
          </div>
          {/* <Button
            variant="outlined"
            sx={{
              py: 2,
              color: "#000",
              borderColor: "#000",
              "&:hover": {
                backgroundColor: "primary.dark",
                color: "primary.contrastText",
                borderColor: "primary.dark",
              },
            }}
          >
            Learn More About OS 3
          </Button> */}
        </motion.div>
      )}
      {images.map((iteme) => (
        <ImageItem key={iteme.title} item={iteme} />
      ))}
    </div>
  );
}

export default ImageScrollInfo;
